var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45509 0.852535C3.36611 0.865531 3.27907 0.905082 3.20314 0.975582L0.433118 3.54345C0.189368 3.7872 0.189368 4.183 0.433118 4.42675L3.20167 6.99463C3.50617 7.27738 4.00001 7.06146 4.00001 6.64746V4.75048H5.50001C9.23696 4.75048 12.25 7.76354 12.25 11.5005V13.0005C12.2486 13.0999 12.267 13.1985 12.304 13.2908C12.3411 13.383 12.3961 13.4669 12.4659 13.5377C12.5357 13.6085 12.6188 13.6647 12.7105 13.7031C12.8022 13.7414 12.9006 13.7612 13 13.7612C13.0994 13.7612 13.1978 13.7414 13.2895 13.7031C13.3812 13.6647 13.4643 13.6085 13.5341 13.5377C13.6039 13.4669 13.6589 13.383 13.696 13.2908C13.7331 13.1985 13.7514 13.0999 13.75 13.0005V11.5005C13.75 6.95293 10.0476 3.25048 5.50001 3.25048H4.00001V1.32275C4.00001 1.01169 3.72203 0.813547 3.45509 0.852535Z",
    fill: "#1F4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyArrow);
export default __webpack_public_path__ + "static/media/reply-arrow.6cc3afbbd539f3319d24ada2865c1b4f.svg";
export { ForwardRef as ReactComponent };